import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface BarChartProps {
  categories: string[];
  series: Array<{ name: string; data: number[]; color?: string }>;
  horizontal?: boolean;
  stacked?: boolean;
  height?: number | string;
  loading?: boolean;
  color?: string;
  showGrid?: boolean;
  xAxisLabel?: string;
  yAxisLabel?: string;
}

export function BarChart({
  categories,
  series,
  horizontal,
  stacked,
  height,
  loading,
  color,
  showGrid = true,
  xAxisLabel,
  yAxisLabel,
}: BarChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'axis' },
    legend: { bottom: 0 },
    grid: { left: 50, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: horizontal
      ? {
          type: 'value',
          name: xAxisLabel,
          splitLine: showGrid ? undefined : { show: false },
        }
      : {
          type: 'category',
          data: categories,
          name: xAxisLabel,
          splitLine: showGrid ? undefined : { show: false },
        },
    yAxis: horizontal
      ? {
          type: 'category',
          data: categories,
          name: yAxisLabel,
          splitLine: showGrid ? undefined : { show: false },
        }
      : {
          type: 'value',
          name: yAxisLabel,
          splitLine: showGrid ? undefined : { show: false },
        },
    series: series.map((s) => ({
      name: s.name,
      type: 'bar',
      stack: stacked ? 'stack' : undefined,
      data: s.data,
      itemStyle: { color: color ?? s.color },
    })),
  };
  return <EChart option={option} height={height} loading={loading} />;
}
